import React from 'react';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="container">
          <h1>About MindLever</h1>
          <p>Harnessing the power of medicinal mushrooms from the Kootenays</p>
        </div>
      </div>

      <main className="main-content">
        <div className="container">
          <div className="about-content-grid">
            <div className="about-card">
              <h2>Our Mission</h2>
              <p>
                At MindLever, we harness the remarkable power of functional mushrooms to support optimal health and wellness.
                Sourced from the pristine forests of the Kootenays in British Columbia, our mission is to provide premium
                mushroom extract powder supplements that help you achieve your health goals naturally. Every product features
                carefully selected medicinal mushrooms, processed to preserve their beneficial compounds.
              </p>
            </div>

            <div className="about-card">
              <h2>Our Mushrooms</h2>
              <p>
                We specialize in a select group of powerful medicinal mushrooms, each chosen for its unique benefits:
              </p>
              <ul className="values-list">
                <li>Lion's Mane for cognitive support and mental clarity</li>
                <li>Reishi for calm, sleep, and immune function</li>
                <li>Chaga for antioxidant power and vitality</li>
                <li>Turkey Tail for immune defense and recovery</li>
                <li>Oyster mushrooms for anti-inflammatory support</li>
                <li>Bear's Paw polypore for sustained energy</li>
              </ul>
            </div>

            <div className="about-card">
              <h2>Why Mushroom Extracts</h2>
              <p>
                All our supplements use concentrated mushroom extract powders, not ground fruiting bodies or mycelium.
                This extraction process breaks down the chitin in mushroom cell walls, making the beneficial compounds
                like beta-glucans and polysaccharides highly bioavailable. The result? Maximum potency and effectiveness
                in every capsule.
              </p>
            </div>
          </div>

          <section className="about-commitment">
            <h2>Our Commitment to Quality</h2>
            <div className="commitment-grid">
              <div className="commitment-item">
                <h4>Extract Powder Quality</h4>
                <p>We use only concentrated mushroom extract powders, ensuring maximum bioavailability of beneficial compounds.</p>
              </div>
              <div className="commitment-item">
                <h4>Sustainable Wildcrafting</h4>
                <p>Responsibly wildcrafted and cultivated in the Kootenays, respecting forest ecology and regeneration.</p>
              </div>
              <div className="commitment-item">
                <h4>Pure Formulations</h4>
                <p>Nothing but mushroom extracts, capsules, and minimal fillers. No mycelium on grain, no additives.</p>
              </div>
              <div className="commitment-item">
                <h4>Traditional Wisdom Meets Science</h4>
                <p>Our formulations honor centuries of traditional use while backed by modern mycological research.</p>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default About;
